import { render, staticRenderFns } from "./modalAddProducts.vue?vue&type=template&id=ecfdd446&scoped=true"
import script from "./modalAddProducts.vue?vue&type=script&lang=js"
export * from "./modalAddProducts.vue?vue&type=script&lang=js"
import style0 from "./modalAddProducts.vue?vue&type=style&index=0&id=ecfdd446&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecfdd446",
  null
  
)

export default component.exports